<!-- 球队展示 -->
<template>
    <div>
        <event-head></event-head>
        <div class="hideTable">
            <el-table :data="teamList">
                <el-table-column label="序号" type="index" align="center"></el-table-column>
                <el-table-column label="头像" align="center">
                    <template slot-scope="scope">
                        <el-image :src="scope.row.logo" style="width: 50px;height:50px"
                            @click="editLogo(scope.row)"></el-image>
                    </template>
                </el-table-column>
                <el-table-column label="球队名称" prop="teamName" align="center"></el-table-column>
                <el-table-column label="联系电话" prop="mobile" align="center"></el-table-column>
                <el-table-column label="组别" prop="teamGroupName" align="center"></el-table-column>
                <el-table-column label="报名时间" prop="signTime" align="center"></el-table-column>
                <el-table-column label="球员数量" prop="playerCount" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="detailView(scope.row)">查看球员</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination layout="total, prev, pager, next" :current-page="pageInfo.page"
            :page-size="pageInfo.pageSize" :total="pageInfo.count"
            @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
    </div>
    </div>
</template>
<script>
import EventHead from '@/common/components/eventHead/EventHead';
export default {
    components: {
        EventHead
    },
    data() {
        return {
            teamId: '',
            teamList: [],
            matchList: [],
            matchInfo: {},
            teamGroupId: 0,
            groupData: [],
            pageInfo: {
                page: 1,
                pageSize: 10,
                count: 0,
            },
    
        };
    },
    mounted() {
        if (localStorage.getItem('matchId')) {
            this.matchInfo = localStorage.getItem('currentMatchId') ? JSON.parse(localStorage.getItem('currentMatchId')) : {};
            this.getTeamList()
        } else {
            this.$confirm('暂无赛事！！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
        }
    },
    methods: {
        // 获取球队
        async getTeamList() {
            const { res } = await this.$http.get(`/Match/MatchTeamList/${this.matchInfo.matchId}/${this.teamGroupId}`);
            this.teamList = res.data || [];
            this.pageInfo.count = res.data.length;
        },
        // 获取组别
        // async getTeamGroupList() {
        //     const { res } = await this.$http.get(`/Match/TeamGroupList/${this.matchInfo.matchId}`);
        //     this.groupData = res.data || [];
        //     if (this.groupData.length) {
        //         this.groupData.push({ teamGroupId: 0, teamGroupName: '全部' })
        //         this.getTeamList()
        //     }
        // },
        // 选择球队
        selectTeam() {
            this.getPlayerList()
        },
        // 查看球员
        detailView(row){
            this.$router.push({
                name: 'playerMange',
                query: {
                    teamId: row.teamId,
                    matchId: this.matchInfo.matchId
                },
            });
        },
        //分页
        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
            this.getTeamList();
        },
        handleCurrentChange(val) {
            this.pageInfo.page = val;
            console.log(1111, val)
            this.getTeamList();
        },
    },
};
</script>
<style lang="scss" scoped>
/deep/.el-input--small .el-input__inner {
    color: #e9e9e9;
}

.hideTable{
    margin-top: 20px;
}
</style>